import { FullScreenProvider } from '@/components/FullScreen';
import { ModelContributionHeader } from '@/dashboards/ModelContributions/components/ModelContributionHeader';
import { ModelContributionProvider } from '@/dashboards/ModelContributions/providers/ModelContributionProvider';
import { useRef } from 'react';
import { ContributionsSection } from './ContributionsSection';

export const ModelContributions = () => {
    const portalRef = useRef<HTMLDivElement>(null);

    return (
        <ModelContributionProvider>
            <ModelContributionHeader />
            <div className="pb-8 px-8 lg:px-16">
                <div className="transition-all duration-300" ref={portalRef} />

                <FullScreenProvider portalRef={portalRef}>
                    <ContributionsSection />
                </FullScreenProvider>
            </div>
        </ModelContributionProvider>
    );
};
